import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './UserSelectModalStyles';

const UserSelectModal = ({ users, onSelectUser, userSelected }) => {
  const { t } = useTranslation();

  return (
    <S.UserSelect
      label={t('processList.userSelectModal.selectLabel')}
      options={users}
      getOptionLabel={option => option.name}
      getOptionValue={option => option.id}
      value={userSelected}
      onChange={onSelectUser}
      className="test-select-user"
    />
  );
};

UserSelectModal.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
  onSelectUser: PropTypes.func,
  userSelected: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

export default UserSelectModal;
